import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { TESTID } from "@/lib/testIds";
import { Loader2, CheckCircle2, AlertCircle, Shield } from "lucide-react";

export default function MagicLinkVerifyPage() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("verifying"); // verifying, mfa, error
  const [error, setError] = useState("");
  const { verifyMagicLink } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setError("No token in URL");
      return;
    }
    (async () => {
      try {
        const res = await verifyMagicLink(token);
        if (res.mfaRequired) {
          navigate("/auth/mfa-challenge");
        } else {
          navigate("/dashboard");
        }
      } catch (err) {
        setStatus("error");
        setError(err.message);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-armada-base flex items-center justify-center px-6">
      <div className="absolute inset-0 dashboard-grid opacity-30 pointer-events-none" />
      <div className="relative w-full max-w-[440px] glass-strong rounded-2xl p-10 text-center animate-fade-up">
        <div className="flex justify-center mb-6">
          <div className="w-14 h-14 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/30 flex items-center justify-center">
            {status === "verifying" ? (
              <Loader2 className="w-7 h-7 text-[#D4AF37] animate-spin" />
            ) : status === "error" ? (
              <AlertCircle className="w-7 h-7 text-red-400" />
            ) : (
              <CheckCircle2 className="w-7 h-7 text-emerald-400" />
            )}
          </div>
        </div>
        <div className="text-[10px] tracking-armada text-[#D4AF37] font-bold mb-2">SOVEREIGN COMMAND</div>
        <h1 data-testid={TESTID.magicVerifyStatus} className="text-2xl font-black text-white">
          {status === "verifying" && "Verifying Magic Link"}
          {status === "error" && "Link Invalid"}
        </h1>
        <p className="text-sm text-zinc-400 mt-3 font-light">
          {status === "verifying" && "Authenticating with the Armada…"}
          {status === "error" && error}
        </p>
        {status === "error" && (
          <Link to="/login" className="inline-flex items-center gap-2 mt-6 btn-ghost-gold">
            <Shield className="w-4 h-4" />
            Return to Command
          </Link>
        )}
      </div>
    </div>
  );
}
